<template>
  <b-form-group v-slot="{ ariaDescribedby }">
    <b-form-radio-group
        v-model="localValue"
        :options="optionsSettledLabels"
        :aria-describedby="ariaDescribedby"
        size="lg"
        :state="state"
        :stacked="stacked"
        @change="$emit('change', $event)"
        text-field="label"
      ></b-form-radio-group>
      <b-form-invalid-feedback :state="state">{{ errorMsg }}</b-form-invalid-feedback>
  </b-form-group>
</template>

<script>
import { BFormGroup, BFormRadioGroup, BFormInvalidFeedback } from 'bootstrap-vue'

const messages = {
  es: {
    'base-radio-group': {
      'error-msg': 'Seleccione una opción'
    }
  },
  en: {
    'base-radio-group': {
      'error-msg': 'Select an option'
    }
  }
}

export default {
  components: {
    BFormGroup,
    BFormRadioGroup,
    BFormInvalidFeedback
  },
  i18n: {
    messages
  },
  props: {
    value: [String, Object, Boolean, Number],
    options: {
      type: Array,
      required: true
    },
    state: {
      type: [Boolean, Object],
      required: false,
      default: null
    },
    stacked: {
      type: Boolean,
      required: false
    },
    errorMsg: {
      type: String,
      required: false,
      default () {
        return this.$t('base-radio-group.error-msg')
      }
    },
    labelsEnabled: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      localValue: null
    }
  },
  created () {
    this.localValue = this.value
    this.$watch('localValue', value => {
      this.$emit('input', value)
    })
    this.$watch('value', newValue => {
        this.localValue = newValue
    })
  },
  computed: {
    optionsSettledLabels () {
      return this.options.map(option => ({
        ...option,
        label: this.labelsEnabled ? option.text || option.value : ''
      }))
    }
  }
}
</script>

<style lang="scss">
.custom-radio.b-custom-control-lg .custom-control-label::after {
  cursor: pointer !important;
}
</style>


// WEBPACK FOOTER //
// src/components/base/forms/BaseRadioGroup.vue